import { ConversationPlatform } from "@redotech/redo-model/conversation";
import { Condition as ModelCondition } from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType } from "../return-flow/condition";
import { RuleTypeDetailsProps } from "./multiple-actions";

export type TicketChannelState = ConversationPlatform[];

export const TICKET_CHANNEL = (
  Details: React.ComponentType<RuleTypeDetailsProps<TicketChannelState>>,
): ConditionType<TicketChannelState, ModelCondition.TicketChannel> => ({
  name: "Ticket channel",
  description() {
    return "Which channel the ticket came from";
  },
  Details(props: RuleTypeDetailsProps<TicketChannelState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model) {
    return model.channels;
  },
  toModel(state) {
    return { type: ModelCondition.TICKET_CHANNEL, channels: state };
  },
  valid() {
    return true;
  },
});
